import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";

const styles = {
  root: {
    display: "flex",
    justifyContent: "space-evenly",
    flexWrap: "wrap"
  },
  card: {
    minWidth: 275,
    maxWidth: 200,
    flex: 1,
    margin: 5
  },
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)"
  },
  title: {
    fontSize: 14
  },
  pos: {
    marginBottom: 12
  }
};

function getAge(d1) {
  var now = new Date();
  var d2 = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate(),
    23,
    59,
    59
  );
  var diff = d2.getTime() - d1.getTime();
  return Math.floor(diff / (1000 * 60 * 60 * 24 * 365.25));
}

function SimpleCard(props) {
  const { classes } = props;

  return (
    <div>
      <Card>
        <CardContent>
          <Typography
            className={classes.title}
            color="textSecondary"
            gutterBottom
          >
            We all have a thirst for wonder
          </Typography>
          <div>
            <img
              style={{ borderRadius: "8px", border: "1px solid gray" }}
              src="./manoj.jpg"
              alt="Schematic"
              width="50%"
            />
          </div>
          <Typography variant="h5" component="h2">
            Manoj Kumar Sahukar
          </Typography>
          <Typography className={classes.pos} color="textSecondary">
            {getAge(new Date(1992, 5, 17, 0, 0, 0))} (if I'm not dead), Male
          </Typography>
          <Typography component="p" align="justify">
            I'm a problem solver, thinker and tinkerer. I used to believe that
            I'm a multipotentialite, and perhaps I still do, dormantly. Then
            again, I choose entrepreneurship as my way of life, cause it let's
            me be me. Whenever I could find time, I write. I prefer creating
            than consuming. I wouldn't call myself ultracrepidarian, but I might
            be. People find me contemplating life and everything in it. When I
            talk to people, I talk problems. I learn how they've handled any
            crisis in their life. So, if you have a problem, I probably have the
            solution.
            <br /> I'm an admirer of human's creative capabilities. I like to
            explore, tinker with and master the best of human creations.
            <br />I strive to achieve better level of ignorance.
            <br /> Talk deep to me.
          </Typography>
        </CardContent>
        <CardActions>
          <Button target="_blank" href="http://manojsahukar.xyz" size="small">
            Personal Website
          </Button>
          <Button
            target="_blank"
            href="https://www.linkedin.com/in/manojsahukar/"
            size="small"
          >
            LinkedIn
          </Button>
          <Button
            target="_blank"
            href="http://manojsahukar.tumblr.com/"
            size="small"
          >
            Tumblr
          </Button>
        </CardActions>
      </Card>
      <br />
    </div>
  );
}

SimpleCard.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(SimpleCard);
